
import store from './store'
import { Vue, Component } from 'vue-property-decorator'

@Component({
	components: {
		AppBar: () => import('./components/AppBar.vue'),
		Content: () => import('./components/Content.vue'),
		Footer: () => import('./components/Footer.vue'),
		NavigationDrawer: () => import('./components/NavigationDrawer.vue'),
		SystemBar: () => import('./components/SystemBar.vue'),
	},
})
export default class App extends Vue {
	store = store
	mounted() {
		setTimeout(() => (this.store.ready = true), 100)
	}
}
